<template>
  <div class="is-flex is-flex-direction-column mb-5">
    <Product
      v-for="index in getProducts.length"
      :key="index - 1"
      :productIndex="index - 1"
    />
    <button
      @click.prevent="addProduct"
      type="button"
      class="add-product-button mb-5"
    >
      <b-icon icon-pack="fas" icon="plus" size="fa-large" />
      <span>{{ $t("mp:new_application.button.add_item") }}</span>
    </button>
  </div>
</template>
<script>
import Product from "./Product.vue";

export default {
  components: { Product },
  computed: {
    getProducts() {
      return this.$store.getters["bnplInStoreApplication/getProducts"];
    },
  },
  methods: {
    addProduct() {
      this.$store.commit("bnplInStoreApplication/addProduct");
    },
  },
};
</script>
<style scoped lang="scss">
.is-flex {
  gap: 24px;
}

.add-product-button {
  display: flex;
  flex-direction: row;

  align-items: center;
  justify-content: flex-start;

  background: white;
  border: none;
  border-radius: 16px;

  padding: 16px;
  gap: 8px;

  font-size: 16px;

  cursor: pointer;

  span {
    line-height: 16px;
  }

  box-shadow: 0px 5px 30px rgba(48, 52, 62, 0.1);
}
</style>
